export default __webpack_public_path__ + "static/media/Image_30.b584179f.png";